<template>
  <div v-frag>
    <b-dropdown-item @click="onClickDropdownItem">
      <span class="dropdown-item-lable">{{ dropdownItemName }}</span>
      <i class="material-icons align-middle material-icons-small text-right">keyboard_arrow_right</i>
    </b-dropdown-item>
    <b-dropdown-divider v-if="dropdownDivider"></b-dropdown-divider>
  </div>
</template>
<script>
export default {
  props: {
    dropdownDivider: {
      type: Boolean,
      default: false
    },
    dropdownItemName: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClickDropdownItem() {
      this.$emit('clickDropdownItem')
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/custom-components/DropdownItemComponent.vue